import { Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CommonAutoComplete from '../Common/CommonAutoComplete'
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import ErrorHandler from '../../lib/errorHandler';
import { addInventory, getInventoryFields, updateInventory } from '../../Redux/Actions/Inventory';
import { InventoryTypeInum } from '../../lib/enum';
import CommonTextField from '../Common/CommonTextField';
import CommonRadioButton from '../Common/CommonRadioButton';
import { useCommonStyles } from '../../utils';
import ErrorMessage from '../Common/ErrorMessage';

const AddUpdateInventory = ({ data, setData, activeTab, selectedItem, setSelectedItem, setIsOpenDrawer, _getInventories }) => {
    // =============== Hooks ===============
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [errors, setErrors] = useState({});
    const [companyPage, setCompanyPage] = useState(1);
    const [companytotalCount, setCompanyTotalCount] = useState();
    const [companyList, setCompanyList] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([])
    const [searchCompany, setSearchCompany] = useState();


    const [sizePage, setSizePage] = useState(1);
    const [sizeTotalCount, setSizeTotalCount] = useState();
    const [sizeList, setSizeList] = useState([]);
    const [sizeOptions, setSizeOptions] = useState([]);
    const [searchSize, setSearchSize] = useState();

    const [groupPage, setGroupPage] = useState(1);
    const [grouptotalCount, setGroupTotalCount] = useState();
    const [groupList, setGroupList] = useState([]);
    const [groupOptions, setGroupOptions] = useState([])
    const [searchGroup, setSearchGroup] = useState();

    const [subGroupPage, setSubGroupPage] = useState(1);
    const [subGrouptotalCount, setSubGroupTotalCount] = useState();
    const [subGroupList, setSubGroupList] = useState([]);
    const [subGroupOptions, setSubGroupOptions] = useState([])
    const [searchSubGroup, setSearchSubGroup] = useState();

    const [typeOfpaperPage, setTypeOfpaperPage] = useState(1);
    const [typeOfpapertotalCount, setTypeOfpaperTotalCount] = useState();
    const [typeOfpaperList, setTypeOfpaperList] = useState([]);
    const [typeOfpaperOptions, setTypeOfpaperOptions] = useState([]);
    const [searchTypeOfpaper, setSearchTypeOfpaper] = useState();

    const [colorPage, setColorPage] = useState(1);
    const [colorTotalCount, setColorTotalCount] = useState();
    const [colorList, setColorList] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [searchColor, setSearchColor] = useState();

    const [micronPage, setMicronPage] = useState(1);
    const [micronTotalCount, setMicronTotalCount] = useState();
    const [micronList, setMicronList] = useState([]);
    const [micronOptions, setMicronOptions] = useState([]);
    const [searchMicron, setSearchMicron] = useState();

    const [chemicalPage, setChemicalPage] = useState(1);
    const [chemicalTotalCount, setChemicalTotalCount] = useState();
    const [chemicalList, setChemicalList] = useState([]);
    const [chemicalOptions, setChemicalOptions] = useState([]);
    const [searchChemical, setSearchChemical] = useState();

    // const [chemicalCodePage, setChemicalCodePage] = useState(1);
    // const [chemicalCodeTotalCount, setChemicalCodeTotalCount] = useState();
    // const [chemicalCodeList, setChemicalCodeList] = useState([]);
    // const [chemicalCodeOptions, setChemicalCodeOptions] = useState([]);
    // const [searchChemicalCode, setSearchChemicalCode] = useState();

    const [chemicalCategoryPage, setChemicalCategoryPage] = useState(1);
    const [chemicalCategoryTotalCount, setChemicalCategoryTotalCount] = useState();
    const [chemicalCategoryList, setChemicalCategoryList] = useState([]);
    const [chemicalCategoryOptions, setChemicalCategoryOptions] = useState([]);
    const [searchChemicalCategory, setSearchChemicalCategory] = useState();

    const [pantoneNumberPage, setPantoneNumberPage] = useState(1);
    const [pantoneNumberTotalCount, setPantoneNumberTotalCount] = useState();
    const [pantoneNumberList, setPantoneNumberList] = useState([]);
    const [pantoneNumberOptions, setPantoneNumberOptions] = useState([]);
    const [searchPantoneNumber, setSearchPantoneNumber] = useState();
    const [releaseStatus, setReleaseStatus] = useState([]);


    // console.log(releaseStatus)
    // ================ Handler ================
    const paperCertificationList = [
        { label: "FSC", value: "FSC" },
        { label: "N/A", value: "N/A" },
    ];

    const releaseStatusOptions = [
        { label: "Release", value: "Release" },
        { label: "Release S", value: "Release S" },
        { label: "NA(Default)", value: "NA(Default)" },
        { label: "Others", value: "Others" },
    ];

    const coatingPreferencesOptions = [
        { label: "Release Polyster Film", value: "Release Polyster Film" },
        { label: "Polyster Film", value: "Polyster Film" },
    ];
    const coatedOptions = [
        { label: "C1S", value: "C1S" },
        { label: "C2S", value: "C2S" },
    ];

    const handleChange = (name, value) => {
        if (name == "coatingPreferences") {
            setData({ ...data, [name]: value, coatedType: null })
        } else if (name == "chemicalName") {
            setData({ ...data, [name]: value, chemicalCode: value?.chemicalCode })
        }
        else {
            setData({ ...data, [name]: value })
        }
    }

    //------------------ Company Name API ------------------
    const _getCompanyNames = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["CompanyName"],
            "limit": 10,
            "page": p ? p : companyPage,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        { (companyList?.length !== companytotalCount) && setCompanyPage(companyPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCompany(searchText ? searchText : "");
            setCompanyTotalCount(response?.payload?.data?.count)
            if (response?.payload?.data) {
                setCompanyList([...companyList, ...response?.payload?.data?.response])
            }
        }
    };
    const handleChangeInputForJobRole = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["CompanyName"],
            "limit": 10,
            "page": p,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        setCompanyPage(2)
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCompany(searchText);
            setCompanyList(response?.payload?.data?.response)
        }
    };

    //------------------  Group API ------------------
    const _getGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Group"],
            "limit": 10,
            "page": p ? p : groupPage,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        { (groupList?.length !== grouptotalCount) && setGroupPage(groupPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchGroup(searchText ? searchText : "");
            setGroupTotalCount(response?.payload?.data?.count)
            if (response?.payload?.data) {
                setGroupList([...groupList, ...response?.payload?.data?.response])
            }
        }
    };

     const _getReleaseStatus = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["releaseStatus"],
            "limit": 10,
            "page": p ? p : groupPage,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        { (groupList?.length !== grouptotalCount) && setGroupPage(groupPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchGroup(searchText ? searchText : "");
            setGroupTotalCount(response?.payload?.data?.count)
            if (response?.payload?.data) {
                setReleaseStatus([...groupList, ...response?.payload?.data?.response])
            }
        }
    };
    const handleChangeInputForGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Group"],
            "limit": 10,
            "page": p,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        setGroupPage(2)
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchGroup(searchText);
            setGroupList(response?.payload?.data?.response)
        }
    };

    //------------------ Sub Group API ------------------
    const _getSubGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["SubGroup"],
            "limit": 10,
            "page": p ? p : subGroupPage,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        { (subGroupList?.length !== subGrouptotalCount) && setSubGroupPage(subGroupPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSubGroup(searchText ? searchText : "");
            setSubGroupTotalCount(response?.payload?.data?.count)
            if (response?.payload?.data) {
                setSubGroupList([...subGroupList, ...response?.payload?.data?.response])
            }
        }
    };
    const handleChangeInputForSubGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["SubGroup"],
            "limit": 10,
            "page": p,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        setSubGroupPage(2)
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSubGroup(searchText);
            setSubGroupList(response?.payload?.data?.response)
        }
    };

    //------------------  Type Of Paper API ------------------
    const _getTypeOfpaper = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["TypeOfPaper"],
            "limit": 10,
            "page": p ? p : typeOfpaperPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (typeOfpaperList?.length !== typeOfpapertotalCount) && setTypeOfpaperPage(typeOfpaperPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchTypeOfpaper(searchText ? searchText : "");
            setTypeOfpaperTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setTypeOfpaperList([...typeOfpaperList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForTypeOfpaper = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["TypeOfpaper"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setTypeOfpaperPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchTypeOfpaper(searchText);
            setTypeOfpaperList(response?.payload?.data?.response);
        }
    };

    //------------------  Size API ------------------
    const _getSize = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Size"],
            "limit": 10,
            "page": p ? p : sizePage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (sizeList?.length !== sizeTotalCount) && setSizePage(sizePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSize(searchText ? searchText : "");
            setSizeTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setSizeList([...sizeList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForSize = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Size"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setSizePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSize(searchText);
            setSizeList(response?.payload?.data?.response);
        }
    };



    //------------------  Color API ------------------
    const _getColor = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Color"],
            "limit": 10,
            "page": p ? p : colorPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (colorList?.length !== colorTotalCount) && setColorPage(colorPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchColor(searchText ? searchText : "");
            setColorTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setColorList([...colorList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForColor = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Color"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setColorPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchColor(searchText);
            setColorList(response?.payload?.data?.response);
        }
    };

    //------------------  Micron API ------------------
    const _getMicron = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Micron"],
            "limit": 10,
            "page": p ? p : micronPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (micronList?.length !== micronTotalCount) && setMicronPage(micronPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchMicron(searchText ? searchText : "");
            setMicronTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setMicronList([...micronList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForMicron = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Micron"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setMicronPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchMicron(searchText);
            setMicronList(response?.payload?.data?.response);
        }
    };

    //------------------  Chemical API ------------------
    const _getChemical = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalName"],
            "limit": 10,
            "page": p ? p : chemicalPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (chemicalList?.length !== chemicalTotalCount) && setChemicalPage(chemicalPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemical(searchText ? searchText : "");
            setChemicalTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setChemicalList([...chemicalList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForChemical = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalName"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setChemicalPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemical(searchText);
            setChemicalList(response?.payload?.data?.response);
        }
    };

    //------------------  Chemical Code API ------------------
    // const _getChemicalCode = async (p, searchText) => {
    //     let response;
    //     let body = {
    //         "inventoryFieldType": InventoryTypeInum["ChemicalCode"],
    //         "limit": 10,
    //         "page": p ? p : chemicalCodePage
    //     };
    //     response = await dispatch(getInventoryFields(body));
    //     { (chemicalCodeList?.length !== chemicalCodeTotalCount) && setChemicalCodePage(chemicalCodePage + 1) }
    //     let error = await ErrorHandler(response, setSnackBar);
    //     if (error) {
    //         setSearchChemicalCode(searchText ? searchText : "");
    //         setChemicalCodeTotalCount(response?.payload?.data?.count);
    //         if (response?.payload?.data) {
    //             setChemicalCodeList([...chemicalCodeList, ...response?.payload?.data?.response]);
    //         }
    //     }
    // };
    // const handleChangeInputForChemicalCode = async (p, searchText) => {
    //     let response;
    //     let body = {
    //         "inventoryFieldType": InventoryTypeInum["ChemicalCode"],
    //         "limit": 10,
    //         "page": p
    //     };
    //     response = await dispatch(getInventoryFields(body));
    //     setChemicalCodePage(2);
    //     let error = await ErrorHandler(response, setSnackBar);
    //     if (error) {
    //         setSearchChemicalCode(searchText);
    //         setChemicalCodeList(response?.payload?.data?.response);
    //     }
    // };

    //------------------  Chemical Category API ------------------
    const _getChemicalCategory = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalCategory"],
            "limit": 10,
            "page": p ? p : chemicalCategoryPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (chemicalCategoryList?.length !== chemicalCategoryTotalCount) && setChemicalCategoryPage(chemicalCategoryPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemicalCategory(searchText ? searchText : "");
            setChemicalCategoryTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setChemicalCategoryList([...chemicalCategoryList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForChemicalCategory = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalCategory"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setChemicalCategoryPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemicalCategory(searchText);
            setChemicalCategoryList(response?.payload?.data?.response);
        }
    };

    //------------------  Pantone Number API ------------------
    const _getPantoneNumber = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["PantoneNumber"],
            "limit": 10,
            "page": p ? p : pantoneNumberPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (pantoneNumberList?.length !== pantoneNumberTotalCount) && setPantoneNumberPage(pantoneNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPantoneNumber(searchText ? searchText : "");
            setPantoneNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setPantoneNumberList([...pantoneNumberList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForPantoneNumber = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["PantoneNumber"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setPantoneNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPantoneNumber(searchText);
            setPantoneNumberList(response?.payload?.data?.response);
        }
    };

    const validStep = () => {
        let formIsValid = true;
        let errors = {}

        if (!data?.secondaryName?.trim()) {
            formIsValid = false
            errors.secondaryName = "Please enter secondary name."
        }
        if (activeTab?.value == 1) {
            if (!data?.size?.size) {
                formIsValid = false
                errors.size = "Please select size."
            }
        }
        if (activeTab?.value == 1) {
            if (!data?.typeOfpaper?.paperType) {
                formIsValid = false
                errors.paperType = "Please select type of paper."
            }
        }
        if ((activeTab?.value == 1 || activeTab?.value == 2)) {
            if (!data?.color?.color) {
                formIsValid = false
                errors.color = "Please select color."
            }
        }
        if ((activeTab?.value == 1)) {
            if (!data?.subGroup?.subGroup) {
                formIsValid = false
                errors.subGroup = "Please select subGroup."
            }
        }
        if ((activeTab?.value == 2)) {
            if (!data?.coatingPreferences?.value) {
                formIsValid = false
                errors.coatingPreferences = "Please select coating preferences."
            }
            if (!data?.micron?.micron) {
                formIsValid = false
                errors.micron = "Please select micron."
            }
        }
        if ((activeTab?.value == 3)) {

            if (!data?.chemicalName?.chemicalName) {
                formIsValid = false
                errors.chemicalName = "Please select chemical name."
            }
            // if (!data?.chemicalCode?.trim()) {
            //     formIsValid = false
            //     errors.chemicalCode = "Please enter chemical code."
            // }
            if (!data?.chemicalCategory?.chemicalCategory) {
                formIsValid = false
                errors.chemicalCategory = "Please select chemical category."
            }
        }
        if ((activeTab?.value == 4)) {
            if (!data?.inkName?.inkName) {
                formIsValid = false
                errors.inkName = "Please select ink name."
            }
        }
        // if ((activeTab?.value == 4)) {
        //     if (!data?.pantoneNumber?.pantoneNumber) {
        //         formIsValid = false
        //         errors.pantoneNumber = "Please select pantone number."
        //     }
        // }
        if ((activeTab?.value == 5 || activeTab?.value == 6)) {
            if (!data?.itemName) {
                formIsValid = false
                errors.itemName = "Please enter item name."
            }
        }

        setErrors(errors)

        return formIsValid;
    }
    // ============= add Inventory Field API =============
    const _addUpdateInventoryField = async () => {
        if (validStep()) {
            setFullPageLoader(true);
            let response;
            let body = {
                inventoryType: activeTab?.value || null,
                companyName: data?.companyName?.companyName || null,
                secondaryName: data?.secondaryName || null,
                group: data?.group?.group || null,
                subGroup: data?.subGroup?.subGroup || null,
                paperType: data?.typeOfpaper?.paperType || null,
                paperCertification: data?.paperCertification || null,
                color: data?.color?.color || null,
                size: Number(data?.size?.size) || null,
                sizeUnit: data?.size?.sizeUnit || null,
                releaseStatus: data?.releaseStatus?.value || null,
                otherReleaseStatus: data?.releaseStatus?.value == "Others" ? data?.otherReleaseStatus : null,
                coatingPreferences: data?.coatingPreferences?.value || null,
                coatedType: data?.coatedType?.value || null,
                micron: data?.micron?.micron || null,
                chemicalName: data?.chemicalName?.chemicalName || null,
                chemicalCode: String(data?.chemicalCode) || null,
                chemicalCategory: data?.chemicalCategory?.chemicalCategory || null,
                itemName: data?.itemName || null,
                // pantoneNumber: data?.pantoneNumber?.pantoneNumber || null,
                inkName: data?.inkName?.inkName || null,
                inkCode: data?.inkName?.inkCode || null,
            }
            if (selectedItem?._id) {
                body._id = selectedItem?._id
            }
            const fn = selectedItem?._id ? updateInventory : addInventory
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setData({})
                    setSelectedItem({})
                    setIsOpenDrawer(false)
                    _getInventories();
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (activeTab?.value == 1 || activeTab?.value == 2 || activeTab?.value == 3 || activeTab?.value == 4) {
            _getCompanyNames();
        }
        if (activeTab?.value == 1) {
            _getGroup();
        }
        if (activeTab?.value == 1) {
            _getSubGroup();
        }
        if (activeTab?.value == 1) {
            _getTypeOfpaper();
            _getColor();
        }
        if (activeTab?.value == 1 || activeTab?.value == 2) {
            _getColor();
        }
        if (activeTab?.value == 1 || activeTab?.value == 2) {
            _getSize();
        }
        if (activeTab?.value == 2) {
            _getMicron();
        }
        if(activeTab?.value == 1) {
            _getReleaseStatus();
        }

        if (activeTab?.value == 3) {
            _getChemical();
            // _getChemicalCode();
            _getChemicalCategory();
        }
        if (activeTab?.value == 4) {
            _getPantoneNumber();
        }
    }, [activeTab])


    useEffect(() => {
        setSizeOptions(sizeList?.map((e) => e));
    }, [sizeList]);

    useEffect(() => {
        setCompanyOptions(companyList?.map((e) => e));
    }, [companyList]);
    

    useEffect(() => {
        setGroupOptions(groupList?.map((e) => e));
    }, [groupList]);

    useEffect(() => {
        setSubGroupOptions(subGroupList?.map((e) => e));
    }, [subGroupList]);

    useEffect(() => {
        setTypeOfpaperOptions(typeOfpaperList?.map((e) => e));
    }, [typeOfpaperList]);

    useEffect(() => {
        setColorOptions(colorList?.map((e) => e));
    }, [colorList]);

    useEffect(() => {
        setMicronOptions(micronList?.map((e) => e));
    }, [micronList]);

    useEffect(() => {
        setChemicalOptions(chemicalList?.map((e) => e));
    }, [chemicalList]);

    // useEffect(() => {
    //     setChemicalCodeOptions(chemicalCodeList?.map((e) => e));
    // }, [chemicalCodeList]);

    useEffect(() => {
        setChemicalCategoryOptions(chemicalCategoryList?.map((e) => e));
    }, [chemicalCategoryList]);

    useEffect(() => {
        setPantoneNumberOptions(pantoneNumberList?.map((e) => e));
    }, [pantoneNumberList]);

    return (
        <Grid container spacing={2} p={3}>
            {(activeTab?.value == 1 || activeTab?.value == 2 || activeTab?.value == 3 || activeTab?.value == 4) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        label="Mill Name"
                        placeholder="Select Mill Name"
                        options={companyOptions || []}
                        getOptionLabel={(option) => option?.companyName || ""}
                        value={data?.companyName || null}
                        onChange={(e, newValue) => handleChange("companyName", newValue)}
                        loadData={(companyOptions?.length !== companytotalCount) ? _getCompanyNames : undefined}
                        handleSearch={(e) => handleChangeInputForJobRole(1, e?.target?.value)}
                        searchValue={searchCompany}
                    />
                </Grid>
            }
            {(activeTab?.value == 4) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        valid
                        label="Ink Name"
                        placeholder="Select Ink Name"
                        options={pantoneNumberOptions || []}
                        getOptionLabel={(option) => option?.inkName || ""}
                        value={data?.inkName || null}
                        onChange={(e, newValue) => handleChange("inkName", newValue)}
                        loadData={(pantoneNumberOptions?.length !== pantoneNumberTotalCount) ? _getPantoneNumber : undefined}
                        handleSearch={(e) => handleChangeInputForPantoneNumber(1, e?.target?.value)}
                        searchValue={searchPantoneNumber}
                    />
                    <ErrorMessage text={(activeTab?.value == 4) && !data?.inkName?.inkName ? errors.inkName : ""} />
                </Grid>
            }
            {(activeTab?.value == 4 && data?.inkName?.inkName) &&
                <Grid item xs={12} sm={6}>
                    <Typography fontSize={"14px"} fontFamily={"Satoshi-Medium"}>Ink Code</Typography>
                    <Typography fontSize={"16px"} mt={1} fontFamily={'Satoshi-Bold'}>{data?.inkName?.inkCode}</Typography>
                </Grid>
            }
            {(activeTab?.value == 5 || activeTab?.value == 6) &&
                <Grid item xs={12} sm={6}>
                    <CommonTextField
                        type="text"
                        valid
                        label="Item name"
                        name="itemName"
                        value={data?.itemName}
                        placeholder="Enter The Item name"
                        onChange={(e) => handleChange("itemName", e.target.value)}
                    />
                    <ErrorMessage text={(activeTab?.value == 5 || activeTab?.value == 6) && !data?.itemName ? errors.itemName : ""} />
                </Grid>
            }
            <Grid item xs={12} sm={6}>
                <CommonTextField
                    type="text"
                    valid
                    label="Secondary Name"
                    name="secondaryName"
                    value={data?.secondaryName}
                    placeholder="Enter The Secondary Name"
                    onChange={(e) => handleChange("secondaryName", e.target.value)}
                />
                <ErrorMessage text={!data?.secondaryName?.trim() ? errors.secondaryName : ""} />
            </Grid>
            {(activeTab?.value == 1) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        label="Group"
                        placeholder="Select Group"
                        options={groupOptions || []}
                        getOptionLabel={(option) => option?.group || ""}
                        value={data?.group || null}
                        onChange={(e, newValue) => handleChange("group", newValue)}
                        loadData={(groupOptions?.length !== grouptotalCount) ? _getGroup : undefined}
                        handleSearch={(e) => handleChangeInputForGroup(1, e?.target?.value)}
                        searchValue={searchGroup}
                    />
                </Grid>
            }
            {(activeTab?.value == 1) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        label="GSM"
                        valid
                        placeholder="Select GSM"
                        options={subGroupOptions || []}
                        getOptionLabel={(option) => option?.subGroup || ""}
                        value={data?.subGroup || null}
                        onChange={(e, newValue) => handleChange("subGroup", newValue)}
                        loadData={(subGroupOptions?.length !== subGrouptotalCount) ? _getSubGroup : undefined}
                        handleSearch={(e) => handleChangeInputForSubGroup(1, e?.target?.value)}
                        searchValue={searchSubGroup}
                    />
                    <ErrorMessage text={(activeTab?.value == 1) && !data?.subGroup?.subGroup ? errors.subGroup : ""} />
                </Grid>
            }
            {(activeTab?.value == 1) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        valid
                        label="Type Of Paper"
                        placeholder="Select Type Of Paper"
                        options={typeOfpaperOptions || []}
                        getOptionLabel={(option) => option?.paperType || ""}
                        value={data?.typeOfpaper || null}
                        onChange={(e, newValue) => handleChange("typeOfpaper", newValue)}
                        loadData={(typeOfpaperOptions?.length !== typeOfpapertotalCount) ? _getTypeOfpaper : undefined}
                        handleSearch={(e) => handleChangeInputForTypeOfpaper(1, e?.target?.value)}
                        searchValue={searchTypeOfpaper}
                    />
                    <ErrorMessage text={activeTab?.value == 1 && !data?.typeOfpaper?.paperType ? errors.paperType : ""} />
                </Grid>
            }
            {(activeTab?.value == 1) &&
                <Grid item xs={12} sm={6}>
                    <Typography sx={{ fontFamily: "Satoshi-Medium", fontSize: "14px", mb: 3 }}> Paper Certification </Typography>
                    <CommonRadioButton
                        radioLabels={paperCertificationList}
                        name="paperCertification"
                        selectedValue={data.paperCertification}
                        handleChange={(e) =>
                            handleChange("paperCertification", e.target.value)
                        }
                        dotColor={"#000000"}
                    />
                </Grid>
            }
            {(activeTab?.value == 1 || activeTab?.value == 2) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        label="Color"
                        valid
                        placeholder="Select Color"
                        options={colorOptions || []}
                        getOptionLabel={(option) => option?.color || ""}
                        value={data?.color || null}
                        onChange={(e, newValue) => handleChange("color", newValue)}
                        loadData={(colorOptions?.length !== colorTotalCount) ? _getColor : undefined}
                        handleSearch={(e) => handleChangeInputForColor(1, e?.target?.value)}
                        searchValue={searchColor}
                    />
                    <ErrorMessage text={(activeTab?.value == 1 || activeTab?.value == 2) && !data?.color?.color ? errors.color : ""} />
                </Grid>
            }
            {(activeTab?.value == 1 || activeTab?.value == 2) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        valid={activeTab?.value == 1 ? true : false}
                        label="Size"
                        placeholder="Select Size"
                        options={sizeOptions || []}
                        getOptionLabel={(option) => `${option?.size} (${option?.sizeUnit})` || ""}
                        value={data?.size || null}
                        onChange={(e, newValue) => handleChange("size", newValue)}
                        loadData={(sizeOptions?.length !== sizeTotalCount) ? _getSize : undefined}
                        handleSearch={(e) => handleChangeInputForSize(1, e?.target?.value)}
                        searchValue={searchSize}
                    />
                    <ErrorMessage text={(activeTab?.value == 1) && !data?.size?.size ? errors.size : ""} />
                </Grid>
            }
            {(activeTab?.value == 1) &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            label="Release Status"
                            placeholder="Select Release Status"
                            options={releaseStatus || []}
                            getOptionLabel={(option) => option?.releaseStatus || ""}
                            value={data?.releaseStatus || null}
                            onChange={(e, newValue) => handleChange("releaseStatus", newValue)}
                        />
                    </Grid>
                    {data?.releaseStatus?.value == "Others" &&
                        <Grid item xs={12} sm={6}>
                            <CommonTextField
                                valid
                                type="text"
                                label="Other Release Status"
                                name="otherReleaseStatus"
                                value={data?.otherReleaseStatus}
                                placeholder="Enter The Other Release Status"
                                onChange={(e) => handleChange("otherReleaseStatus", e.target.value)}
                            />
                        </Grid>
                    }
                </>
            }
            {(activeTab?.value == 2) &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            label="Coating Preferences"
                            valid
                            placeholder="Select Coating Preferences"
                            options={coatingPreferencesOptions || []}
                            getOptionLabel={(option) => option?.label || ""}
                            value={data?.coatingPreferences || null}
                            onChange={(e, newValue) => handleChange("coatingPreferences", newValue)}
                        />
                        <ErrorMessage text={(activeTab?.value == 2) && !data?.coatingPreferences?.value ? errors.coatingPreferences : ""} />
                    </Grid>
                    {data?.coatingPreferences?.label == "Release Polyster Film" &&
                        <Grid item xs={12} sm={6}>
                            <CommonAutoComplete
                                label="Coated Type"
                                placeholder="Select Coated Type"
                                options={coatedOptions || []}
                                getOptionLabel={(option) => option?.label || ""}
                                value={data?.coatedType || null}
                                onChange={(e, newValue) => handleChange("coatedType", newValue)}
                            />
                        </Grid>
                    }
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            label="Micron"
                            valid
                            placeholder="Select Micron"
                            options={micronOptions || []}
                            getOptionLabel={(option) => option?.micron || ""}
                            value={data?.micron || null}
                            onChange={(e, newValue) => handleChange("micron", newValue)}
                            loadData={(micronOptions?.length !== micronTotalCount) ? _getMicron : undefined}
                            handleSearch={(e) => handleChangeInputForMicron(1, e?.target?.value)}
                            searchValue={searchMicron}
                        />
                        <ErrorMessage text={(activeTab?.value == 2) && !data?.micron?.micron ? errors.micron : ""} />
                    </Grid>
                </>
            }
            {(activeTab?.value == 3) &&
                <>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            label="Chemical"
                            valid
                            placeholder="Select Chemical"
                            options={chemicalOptions || []}
                            getOptionLabel={(option) => option?.chemicalName || ""}
                            value={data?.chemicalName || null}
                            onChange={(e, newValue) => handleChange("chemicalName", newValue)}
                            loadData={(chemicalOptions?.length !== chemicalTotalCount) ? _getChemical : undefined}
                            handleSearch={(e) => handleChangeInputForChemical(1, e?.target?.value)}
                            searchValue={searchChemical}
                        />
                        <ErrorMessage text={(activeTab?.value == 3) && !data?.chemicalName?.chemicalName ? errors.chemicalName : ""} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonTextField
                            valid
                            type="text"
                            label="Chemical Code"
                            name="otherReleaseStatus"
                            value={data?.chemicalCode}
                            disabled
                            placeholder="Enter The Chemical Code"
                        />
                        {/* <CommonAutoComplete
                            label="Chemical Code"
                            valid
                            placeholder="Select Chemical Code"
                            options={chemicalCodeOptions || []}
                            getOptionLabel={(option) => option?.chemicalCode || ""}
                            value={data?.chemicalCode || null}
                            onChange={(e, newValue) => handleChange("chemicalCode", newValue)}
                            loadData={(chemicalCodeOptions?.length !== chemicalCodeTotalCount) ? _getChemicalCode : undefined}
                            handleSearch={(e) => handleChangeInputForChemicalCode(1, e?.target?.value)}
                            searchValue={searchChemicalCode}
                        /> */}
                        {/* <ErrorMessage text={(activeTab?.value == 3) && !data?.chemicalCode?.trim() ? errors.chemicalCode : ""} /> */}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            label="Chemical Category"
                            placeholder="Select Chemical Category"
                            options={chemicalCategoryOptions || []}
                            getOptionLabel={(option) => option?.chemicalCategory || ""}
                            value={data?.chemicalCategory || null}
                            onChange={(e, newValue) => handleChange("chemicalCategory", newValue)}
                            loadData={(chemicalCategoryOptions?.length !== chemicalCategoryTotalCount) ? _getChemicalCategory : undefined}
                            handleSearch={(e) => handleChangeInputForChemicalCategory(1, e?.target?.value)}
                            searchValue={searchChemicalCategory}
                            valid
                        />
                        <ErrorMessage text={(activeTab?.value == 3) && !data?.chemicalCategory?.chemicalCategory ? errors.chemicalCategory : ""} />
                    </Grid>
                </>
            }

            {/* {(activeTab?.value == 4) &&
                <Grid item xs={12} sm={6}>
                    <CommonAutoComplete
                        valid
                        label="Pantone Number"
                        placeholder="Select Pantone Number"
                        options={pantoneNumberOptions || []}
                        getOptionLabel={(option) => option?.pantoneNumber || ""}
                        value={data?.pantoneNumber || null}
                        onChange={(e, newValue) => handleChange("pantoneNumber", newValue)}
                        loadData={(pantoneNumberOptions?.length !== pantoneNumberTotalCount) ? _getPantoneNumber : undefined}
                        handleSearch={(e) => handleChangeInputForPantoneNumber(1, e?.target?.value)}
                        searchValue={searchPantoneNumber}
                    />
                    <ErrorMessage text={(activeTab?.value == 4) && !data?.pantoneNumber?.pantoneNumber ? errors.pantoneNumber : ""} />
                </Grid>
            } */}
            <Grid item xs={12} display={"flex"} gap={2} mt={1}>
                <Button className={classes.saveButton} onClick={() => _addUpdateInventoryField()}>{selectedItem?._id ? "Update" : "Create"}</Button>
                <Button className={classes.cancelButton} onClick={() => { setIsOpenDrawer(false); setSelectedItem({}); setData({}) }}>Cancel</Button>
            </Grid>
        </Grid>
    )
}

export default AddUpdateInventory